// src/utils/questionBank.js
export const QUESTION_TYPES = [
    { value: 'short', label: 'Kısa Cevap' },
    { value: 'long', label: 'Uzun Cevap' },
    { value: 'multiselect', label: 'Çoklu Seçim' },
    { value: 'single', label: 'Tek Seçim' },
    { value: 'yesno', label: 'Evet/Hayır' },
    { value: 'dropdown', label: 'Açılır Liste' },
    { value: 'citydistrict', label: 'İl / İlçe' },
];